import React from 'react';
import ContactUs from 'pages/lien-he-tnh';
import AppConfigService from '@services/app-config.service';
import {getSeoOnPage} from '@helper/seo/seo';
import {NextSeo} from 'next-seo';

export default function ContactPage(props) {
    const {seoPage} = props;
    
    return (
        <>
            {seoPage && <NextSeo {...seoPage} />}
            <ContactUs {...props} />
        </>
    );
}

export async function getServerSideProps(context) {
    let seoPage = null;
    try {
        const appConfigService = new AppConfigService(context);
        const seoConfig = await appConfigService.getAppConfig({page: 'SEO'});
        seoPage = getSeoOnPage('LIENHE', seoConfig);
        
        const webUrl = process.env.NEXT_PUBLIC_WEB_URL || 'https://tnh.com.vn';
        seoPage.canonical = `${webUrl}/lien-he`;
        if (seoPage.openGraph) {
            seoPage.openGraph.url = `${webUrl}/lien-he`;
        }
    } catch (error) {
        console.error('Failed to fetch SEO for contact page:', error);
    }
    
    return {props: {seoPage}};
}
ContactPage.isHideSearch = true;
